var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFactCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 0C25.3958 0 26 0.270833 26.5 0.8125C27.0417 1.3125 27.3125 1.9375 27.3125 2.6875V21.3125C27.3125 22.0625 27.0417 22.7083 26.5 23.25C26 23.75 25.3958 24 24.6875 24H3.3125C2.60417 24 1.97917 23.75 1.4375 23.25C0.9375 22.7083 0.6875 22.0625 0.6875 21.3125V2.6875C0.6875 1.9375 0.9375 1.3125 1.4375 0.8125C1.97917 0.270833 2.60417 0 3.3125 0H24.6875ZM11.3125 18.6875V16H4.6875V18.6875H11.3125ZM11.3125 13.3125V10.6875H4.6875V13.3125H11.3125ZM11.3125 8V5.3125H4.6875V8H11.3125ZM17.75 16L23.875 9.875L22 8L17.75 12.25L15.875 10.3125L14 12.1875L17.75 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheck);
export default __webpack_public_path__ + "static/media/fact_check.282471de83d947ab2664b8bb83c9acd4.svg";
export { ForwardRef as ReactComponent };